import React, {useRef, useState} from 'react';
import API from "../../../API";
import {BASE_URL, FILE_URL} from "../../../../config";
import {ru} from "../../../data/ru";
import {by} from "../../../data/by";
import style from './addFile.module.css'
import  {ReactComponent as WrappingIcon} from '../../../../img/wrapping.svg'

const AddFile = () => {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdThree : by.RoleIdThree;

    const filePicker = useRef(null)
    const [file, setFile] = useState([])
    const [width, setWidth] = useState([])
    const [height, setHeight] = useState([])
    const [wrapping, setWrapping] = useState([])
    const api = new API();

    function handlerWrapper(status,number) {
        let wrapper = [...wrapping]
        if (wrapper[number] === status) {
            wrapper[number] = 'none'
            setWrapping(wrapper)
        } else {
            wrapper[number] = status
            setWrapping(wrapper)
        }
    }
    function handlerWidth(e,number){
        let arrWidth = [...width]
        arrWidth[number]= e.target.value;
        setWidth(arrWidth)
    }
    function handlerHeight(e,number){
        let arrHeight = [...height]
        arrHeight[number]= e.target.value;
        setHeight(arrHeight)
    }
    function handlerPick() {
        filePicker.current.click();
    }

    async function handleUpload(selectedFile) {
        if (selectedFile) {
            // Создаем объект Image
            const img = new Image();

            // Создаем обещание, которое будет разрешено, когда изображение будет загружено
            const imgLoaded = new Promise((resolve, reject) => {
                img.onload = resolve;
                img.onerror = reject;
            });

            // Читаем содержимое файла в объект Image
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => {
                img.src = reader.result;
            };

            // Ожидаем загрузки изображения
            await imgLoaded;

            // Получаем разрешение изображения

            setWidth(prev=>[...prev,img.width])
            setHeight(prev=>[...prev,img.height])
            setWrapping((prev=>[...prev,'none']))
            let data = await api.sendFiles([selectedFile])
            setFile([...file, data])
        }
    }

    async function onChangeDrag(e) {
        e.stopPropagation();
        e.preventDefault();
        await handleUpload(e.dataTransfer.files[0])
    }

    function muteEvent(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    return (
        <div style={{margin: '0px 10px'}}>
            <div className={style.task_header_item}>
                <h2>{language.addFile}</h2>
            </div>
            <div className={style.addFileBox}>
                <button className={style.task_answers_btn} onClick={() => handlerPick()}>{language.addFile}</button>
            </div>
            <div className={style.addFileBox}>
                <div className={style.addFileDropAria}
                     onDragOver={e => muteEvent(e)}
                     onDragEnter={e => muteEvent(e)}
                     onDragLeave={e => muteEvent(e)}
                     onDrop={e => onChangeDrag(e)}
                >
                    <input type="file" hidden={true} ref={filePicker} onChange={e => handleUpload(e.target.files[0])}/>
                    {file.length !== 0 ? file.map((item,i) => (
                            <div key={Object.values(item)[0]}>
                                <div className={style.imageContainer}>
                                    <h1 className={style.fileName}>{Object.keys(item)[0]}:</h1>
                                    <img src={BASE_URL + FILE_URL + '/' + Object.values(item)[0]} alt='img'
                                         width={'180px'}/>
                                    <div className={style.parameterContainer}>
                                        <h1>{language.parameters}:</h1>
                                            <div>
                                                <div className={style.parameterStr}>
                                                    <nobr>{language.width} (px)</nobr>
                                                    <input type={'number'} value={width[i]} min={10} onChange={e => handlerWidth(e, i)}
                                                           className={style.addInput}/>
                                                </div>
                                                <div className={style.parameterStr}>
                                                    <nobr>{language.height} (px)</nobr>
                                                    <input type={'number'} value={height[i]} min={10} onChange={e => handlerHeight(e, i)}
                                                           className={style.addInput}/>
                                                </div>
                                            </div>
                                            <div>
                                                <h1>{language.wrapping}</h1>
                                                <button onClick={()=>{handlerWrapper('left',i)}}
                                                        className={`${style.wrappingButton} ${wrapping[i]==='left'?style.activeWrapping:''}`}
                                                ><WrappingIcon style={{ transform: 'scale(-1, 1)'}}/></button> {/* обтекание справа*/}
                                                <button onClick={()=>{handlerWrapper('right',i)}}
                                                        className={`${style.wrappingButton} ${wrapping[i]==='right'?style.activeWrapping:''}`}
                                                ><WrappingIcon /></button> {/* обтекание слева*/}
                                            </div>
                                    </div>
                                    <h1 className={`${style.fileCode} ${style.fileName}`}>код файла: {`{!img:${Object.values(item)[0]},property:{width:${width[i]},height:${height[i]},wrapping:${wrapping[i]}}!}`}</h1>
                                </div>
                            </div>
                        )) :
                        <pre className={style.addFileText}>
                            {language.addFileText}
                        </pre>
                    }
                </div>
            </div>
        </div>
    );
};

export default AddFile;